import React from 'react';
import './Footer.css';

const navLinks = [
  { label: 'Home',         id: 'hero' },
  { label: 'About',        id: 'about' },
  { label: 'Services',     id: 'services' },
  { label: 'Countries',    id: 'countries' },
  { label: 'Requirements', id: 'requirements' },
  { label: 'FAQ',          id: 'faq' },
  { label: 'Contact',      id: 'contact' },
];

const services = [
  'Tourist Visa Assistance',
  'eVisa Assistance',
  'ETA Processing',
  'Digital Arrival Cards',
  'Document Review',
  'Visa Consultation',
  'Travel Insurance',
  'Flight & Hotel Bookings',
];

export default function Footer() {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer className="footer">
      {/* CTA band */}
      <div className="footer-band">
        <div className="container">
          <div className="footer-band-inner">
            <div className="footer-band-text">
              <h3>Ready to Start Your Visa Journey?</h3>
              <p>Apply now or chat with our visa experts on WhatsApp</p>
            </div>
            <div className="footer-band-btns">
              <a
                href="#contact"
                className="btn btn-teal btn-lg"
                onClick={e => { e.preventDefault(); go('contact'); }}
              >
                <i className="fas fa-paper-plane"></i> Apply Now
              </a>
              <a href="https://wa.me/918287450060" target="_blank" rel="noopener noreferrer" className="btn btn-wa btn-lg">
                <i className="fab fa-whatsapp"></i> Chat on WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main grid */}
      <div className="container">
        <div className="footer-grid">

          {/* Brand */}
          <div className="footer-brand-col">
            <div className="footer-logo" onClick={() => go('hero')}>
              <img src="/roamlife-footer-logo.png" alt="RoamLife" />
            </div>
            <p className="footer-desc">
              Your trusted digital-first travel documentation partner helping Indian travelers
              with tourist visas and travel documentation worldwide.
            </p>
            <div className="footer-social">
              <a href="https://www.facebook.com/DREAMAHOLIDAY" target="_blank" rel="noopener noreferrer"
                className="soc fb" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://www.instagram.com/dreamaholiday/" target="_blank" rel="noopener noreferrer"
                className="soc ig" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.linkedin.com/company/dreamaholidayindia/" target="_blank" rel="noopener noreferrer"
                className="soc li" aria-label="LinkedIn">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="https://wa.me/918287450060" target="_blank" rel="noopener noreferrer"
                className="soc wa" aria-label="WhatsApp">
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              {navLinks.map((l, i) => (
                <li key={i}>
                  <button onClick={() => go(l.id)}>
                    <i className="fas fa-chevron-right"></i> {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="footer-col">
            <h4>Our Services</h4>
            <ul>
              {services.slice(0,7).map((s, i) => (
                <li key={i}>
                  <button onClick={() => go('services')}>
                    <i className="fas fa-chevron-right"></i> {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-col">
            <h4>Contact</h4>
            <a href="tel:+918287908005" className="footer-contact-item">
              <i className="fas fa-phone"></i> +91 8287908005
            </a>
            <a href="https://wa.me/918287450060" target="_blank" rel="noopener noreferrer" className="footer-contact-item">
              <i className="fab fa-whatsapp"></i> +91 8287450060
            </a>
            <a href="mailto:hello@roamlife.in" className="footer-contact-item">
              <i className="fas fa-envelope"></i> hello@roamlife.in
            </a>
            <a href="https://www.roamlife.in" target="_blank" rel="noopener noreferrer" className="footer-contact-item">
              <i className="fas fa-globe"></i> www.roamlife.in
            </a>
            <div className="footer-contact-item">
              <i className="fas fa-location-dot"></i>
              <span>Madhuban Tower, Mahipalpur, New Delhi – 110037</span>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="footer-bottom">
          <p className="footer-copy">
            © {new Date().getFullYear()} RoamLife. All rights reserved.
          </p>
          <div className="footer-legal">
            <button onClick={() => {}}>Privacy Policy</button>
            <span>·</span>
            <button onClick={() => {}}>Terms & Conditions</button>
          </div>
        </div>
      </div>
    </footer>
  );
}
